"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _user = require('redux/actions/user');

var _BaseForm2 = require('components/BaseForm');

var _BaseForm3 = _interopRequireDefault(_BaseForm2);

var _modal = require('redux/actions/modal');

var _reactSAlert = require('react-s-alert');

var _reactSAlert2 = _interopRequireDefault(_reactSAlert);

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmOldMail = (_dec = (0, _reactRedux.connect)(function (state) {
    return {
        error: state.user.error,
        errorCode: state.user.errorCode,
        preload: state.user.preload,
        changeWithCode: state.user.changeWithCode,
        user: state.auth.user,
        lang: state.lang
    };
}, { confirmMailWithCode: _user.confirmMailWithCode, resetError: _user.resetError, hide: _modal.hide }), _dec(_class = (_temp = _class2 = function (_BaseForm) {
    (0, _inherits3.default)(ConfirmOldMail, _BaseForm);

    function ConfirmOldMail(props, context) {
        (0, _classCallCheck3.default)(this, ConfirmOldMail);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ConfirmOldMail.__proto__ || (0, _getPrototypeOf2.default)(ConfirmOldMail)).call(this, props, context));

        _this.handlerChangeInput = function (event) {
            _this.setState({
                code: event.target.value
            });
        };

        _this.state = {
            code: ''
        };
        return _this;
    }

    (0, _createClass3.default)(ConfirmOldMail, [{
        key: 'onSubmit',
        value: function onSubmit(event) {
            (0, _get3.default)(ConfirmOldMail.prototype.__proto__ || (0, _getPrototypeOf2.default)(ConfirmOldMail.prototype), 'onSubmit', this).call(this, event);

            if (this.isValid()) {
                this.props.confirmMailWithCode(this.props.user.pipo_id, this.props.user.email, this.state.code);
                this.props.resetError();
                this.setState({
                    code: ''
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.resetError();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                changeWithCode = _props.changeWithCode,
                lang = _props.lang;


            if (changeWithCode !== nextProps.changeWithCode && nextProps.changeWithCode) {
                this.props.hide();
                setTimeout(function () {
                    _reactSAlert2.default.success(lang['store.confirm_old_mail.success'], { position: 'top-right', effect: 'slide', timeout: 5000 });
                }, 1000);
            }
        }

        /**
         * Валидация по всем методам проверки
         *
         * @returns {boolean}
         */

    }, {
        key: 'isValid',
        value: function isValid() {
            return this.state.code.length > 0;
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('ConfirmOldMail', null, { folderName: "ConfirmOldMail" });

            return _react2.default.createElement(View, {
                code: this.state.code,
                onSubmit: this.onSubmit,
                disabledSubmit: !this.isValid(),
                preload: this.props.preload,
                error: this.props.error,
                onChange: this.handlerChangeInput,
                errorCode: this.props.errorCode,
                lang: this.props.lang
            });
        }
    }]);
    return ConfirmOldMail;
}(_BaseForm3.default), _class2.propTypes = {
    lang: _react.PropTypes.object
}, _temp)) || _class);
exports.default = ConfirmOldMail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ConfirmOldMail/ConfirmOldMail.jsx
// module id = 1649
// module chunks = 0